import { render, staticRenderFns } from "./LearningUnitScoreDescriptionCard.vue?vue&type=template&id=65edad25&"
import script from "./LearningUnitScoreDescriptionCard.vue?vue&type=script&lang=js&"
export * from "./LearningUnitScoreDescriptionCard.vue?vue&type=script&lang=js&"
import style0 from "./LearningUnitScoreDescriptionCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports